// @flow
import React from "react";
import BasicSelect from "../basicSelect/basicSelect";
import styles from "./selectWithAdd.scss";

const closeIcnUrl = require("../../../../assets/images/close_icn.svg");

type Props = {
  options: Array<Object>,
  placeholder: string,
  onSelectOption: Function,
  onChangeInput?: Function,
  idAccessor?: string,
  selectedOptions?: Array<Object>
};

type State = {
  showOptionsArr: Array<boolean>,
  selectedOptions: Array<any>
};

class SelectWithAdd extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(this.props.selectedOptions);
  }

  getInitialState(options) {
    if (!options || !options.length) {
      return {
        showOptionsArr: [false],
        selectedOptions: [{}]
      };
    }
    const showOptionsArr = [];
    const initialSelectedOptions = [];
    options.forEach(option => {
      showOptionsArr.push(false);
      initialSelectedOptions.push(option);
    });
    return {
      showOptionsArr,
      selectedOptions: initialSelectedOptions
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedOptions !== nextProps.selectedOptions) {
      this.handleSelectedOptionsChange(nextProps.selectedOptions);
    }
  }

  onChangeInput(input) {
    if (this.props.onChangeInput) {
      this.props.onChangeInput(input);
    }
  }

  onChangeOption(val, event, index) {
    const showOptionsArr = Object.assign([], this.state.showOptionsArr);
    showOptionsArr[index] = false;
    const selectedOptions = Object.assign([], this.state.selectedOptions);
    selectedOptions[index] = event;
    this.setState(
      {
        showOptionsArr,
        selectedOptions
      },
      () => {
        this.onSelectOption();
      }
    );
  }

  onSelectOption() {
    const arrayToReturn = [];
    this.state.selectedOptions.forEach(option => {
      if (this.props.idAccessor && option[this.props.idAccessor]) {
        arrayToReturn.push(option[this.props.idAccessor]);
      } else if (option.val) {
        arrayToReturn.push(option.val);
      }
    });
    this.props.onSelectOption(arrayToReturn);
  }

  handleSelectedOptionsChange(options) {
    this.setState(this.getInitialState(options));
  }

  addSelect() {
    const showOptionsArr = Object.assign([], this.state.showOptionsArr);
    showOptionsArr.push(false);
    const selectedOptions = Object.assign([], this.state.selectedOptions);
    selectedOptions.push({});
    this.setState({
      showOptionsArr,
      selectedOptions
    });
  }

  deleteSelect(index) {
    if (this.state.showOptionsArr.length > 1) {
      const showOptionsArr = Object.assign([], this.state.showOptionsArr);
      showOptionsArr.splice(index, 1);
      const selectedOptions = Object.assign([], this.state.selectedOptions);
      selectedOptions.splice(index, 1);
      this.setState(
        {
          selectedOptions,
          showOptionsArr
        },
        () => {
          this.onSelectOption();
        }
      );
    }
  }

  renderInputBox(showOptions, index) {
    return (
      <div className="l-row a-center">
        <div className={`${styles.selectBox}`}>
          <BasicSelect
            label={this.props.placeholder || "Select option"}
            optionsArrOfObj={this.props.options || []}
            onSelect={(val, event) => {
              this.onChangeOption(val, event, index);
            }}
            enableSearch={true}
            showOptions={showOptions}
            onChangeInput={val => {
              this.onChangeInput(val);
            }}
            selectedOpt={
              this.state.selectedOptions
                ? this.state.selectedOptions[index].name
                : null
            }
          />
        </div>
        <div onClick={() => this.deleteSelect(index)}>
          <img className={styles.deleteIcon} src={closeIcnUrl} alt="remove" />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.showOptionsArr.map((showOptions, i) => (
          <div key={i}>{this.renderInputBox(showOptions, i)}</div>
        ))}
        <div className={`${styles.addButton}`} onClick={() => this.addSelect()}>
          + Add
        </div>
      </div>
    );
  }
}

SelectWithAdd.defaultProps = {
  onChangeInput: null,
  idAccessor: null,
  selectedOptions: null
};

export default SelectWithAdd;



// WEBPACK FOOTER //
// ./app/components/commons/formElements/selectWithAdd/selectWithAdd.js